import pluralize from 'pluralize';

angular.module('filters').filter('membershipPlanSequenceRepeatingCost', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(plan, currency) {
    var amount, cost_repeat, date, interval, symbol;
    if (plan.cost_repeat > 0 && ('recurring' === plan.type || 'recurring' === plan.plan_type)) {
      symbol = currency || $rootScope.gym.currency_symbol;
      cost_repeat = $filter('currency')(plan.cost_repeat, symbol);
      amount = plan.charge_interval_number > 1 ? `${cost_repeat} every ${plan.charge_interval_number} ${plan.charge_interval_unit}` : `${cost_repeat}/${pluralize.singular(plan.charge_interval_unit)}`;
      date = (function() {
        switch (plan.default_repeat_date_strategy) {
          case 'start_repeat_payments_one_period_after_upfront':
            interval = $filter('pluralize')(plan.charge_interval_unit, plan.charge_interval_number, true);
            return `${interval} after initial payment`;
          case 'start_repeat_payments_relative_to_start_or_upfront':
            interval = $filter('pluralize')(plan.relative_repeat_date_unit, plan.relative_repeat_date_number, true);
            return `${interval} after membership starts`;
          case 'start_repeat_payments_on_membership_start_date':
            return 'on membership start date';
        }
      })();
      return `${amount}, starting ${date}`;
    } else {
      return "No recurring payment";
    }
  };
}]);
